
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test-series/[slug]/[courseUID]/full-schedule",
      function () {
        return require("private-next-pages/test-series/[slug]/[courseUID]/full-schedule.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/test-series/[slug]/[courseUID]/full-schedule"])
      });
    }
  